import { graphql } from "@server/gql";

export const signupUserMutation = graphql(/* GraphQL */ `
  mutation signupUser($email: String!, $countryCode: String!) {
    user: signupUser(email: $email, countryCode: $countryCode) {
      ...user
    }
  }
`);
